import { getDataType } from '@/components/ExampleCrudPane/utils';
import { RunSchema } from '@/types/schema';

export function evaluateIfRunCanBeAddedToDataset(
  run: Pick<RunSchema, 'run_type' | 'inputs'>,
  data_type: 'kv' | 'llm' | 'chat'
) {
  // Any run can be added to a kv dataset.
  if (data_type === 'kv') {
    return true;
  }

  if (data_type === 'llm' || data_type === 'chat') {
    return data_type === getDataType(undefined, run);
  }

  return false;
}
